import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=f5833cb4&scoped=true&"
import script from "./Simulator.vue?vue&type=script&lang=js&"
export * from "./Simulator.vue?vue&type=script&lang=js&"
import style0 from "./Simulator.vue?vue&type=style&index=0&id=f5833cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5833cb4",
  null
  
)

export default component.exports